import { HierarchyContextProps, IHierarchyActionSetSaveRequestStatus } from "../interface";

/**
 * Updates the hierarchy save request status.
 *
 * @param state - The current hierarchy context state.
 * @param action - The set-hierarchy-save-request-status action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_setHierarchySaveRequestStatus = (
  state: HierarchyContextProps,
  action: IHierarchyActionSetSaveRequestStatus,
): HierarchyContextProps => ({
  ...state,
  saveRequestStatus: action.saveRequestStatus,
});
